import { Injectable, inject } from '@angular/core';
import { AgencyNumberLookupResponse } from '@shared/models/agency-number';
import { Observable, of, shareReplay } from 'rxjs';
import { ClubHubDataService } from './clubhub-data.service';

@Injectable({
  providedIn: 'root',
})
export class AgencyNumberService {
  private readonly dataService = inject(ClubHubDataService);

  private readonly lookupCache = new Map<number, Observable<AgencyNumberLookupResponse>>();

  public lookupAgencyNumber(agencyNumber: number | null, loading = false): Observable<AgencyNumberLookupResponse> {
    if (agencyNumber === null || agencyNumber < 0) {
      return of({ valid: false, result: 'Invalid agency number', isMasterAgency: false });
    }
    if (!this.lookupCache.has(+agencyNumber)) {
      this.lookupCache.set(
        +agencyNumber,
        this.dataService.get<AgencyNumberLookupResponse>(`Agency/Lookup?agencyNumber=${agencyNumber}`, { loading }).pipe(shareReplay(1)),
      );
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.lookupCache.get(+agencyNumber)!;
  }
}
